// extracted by mini-css-extract-plugin
export default {"cls1":"VeloNotification-NotificationInfo_cls1__po-qk","cls2":"VeloNotification-NotificationInfo_cls2__wMLHT VeloNotification-NotificationInfo_cls1__po-qk"};